(() => {
  const selector = '[data-lmb-home-popup]';
  const cookieName = 'lmb_home_popup';

  const loadPopupImage = (popup) => {
    const imageTemplate = popup.querySelector('template[data-lmb-popup-picture]');
    if (!imageTemplate) return;
    imageTemplate.replaceWith(imageTemplate.content.cloneNode(true));
  };

  const hasCookie = () => document.cookie.split('; ').some((entry) => entry.startsWith(`${cookieName}=`));

  const setCookie = (days) => {
    const seconds = Math.max(Number(days) || 30, 1) * 24 * 60 * 60;
    document.cookie = `${cookieName}=1; max-age=${seconds}; path=/; SameSite=Lax`;
  };

  const initialize = (popup) => {
    if (!popup || popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    const closeButtons = popup.querySelectorAll('[data-lmb-popup-close]');
    const forcePreview = new URLSearchParams(window.location.search).get('lmb_popup_preview') === '1';
    const hasFormFeedback = Boolean(popup.querySelector('[role="status"], [role="alert"]'));
    const delay = hasFormFeedback || forcePreview || window.Shopify?.designMode ? 100 : Math.max(Number.isFinite(Number(popup.dataset.delay)) ? Number(popup.dataset.delay) : 6000, 0);

    let previousFocus;
    const openPopup = (manual = false) => {
      if (popup.open || (!manual && !forcePreview && !hasFormFeedback && hasCookie())) return;
      previousFocus = document.activeElement;
      loadPopupImage(popup);
      popup.showModal();
      const feedback = popup.querySelector('[role="status"], [role="alert"]');
      const email = popup.querySelector('input[type="email"]');
      window.setTimeout(() => (feedback || email || closeButtons[0])?.focus(), 80);
    };

    const closePopup = () => {
      if (!popup.open) return;
      setCookie(popup.dataset.cookieDays);
      popup.close();
      if (previousFocus?.isConnected) previousFocus.focus();
    };

    closeButtons.forEach((button) => button.addEventListener('click', closePopup));
    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
      closePopup();
    });
    popup.addEventListener('click', (event) => {
      if (event.target === popup) closePopup();
    });

    document.querySelectorAll('[data-lmb-popup-open]').forEach((button) => button.addEventListener('click', () => openPopup(true)));
    if (forcePreview || hasFormFeedback || window.Shopify?.designMode) window.setTimeout(() => openPopup(), delay);
    popup.querySelector('form')?.addEventListener('submit', () => popup.close());
  };

  const initializeAll = (root = document) => root.querySelectorAll(selector).forEach(initialize);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:section:select', (event) => {
    const popup = event.target.querySelector(selector);
    if (popup && !popup.open) {
      loadPopupImage(popup);
      popup.showModal();
    }
  });
})();

